import React from "react";
import styled from "styled-components";
import CollapsibleSection from "../../components/CollapsibleSection";
import { DeleteButton } from "../../components/buttons";
import RouteForm from "./RouteForm";

const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

const Name = styled.div`
  font-weight: bold;
`;

const Meta = styled.div`
  font-size: 12px;
  opacity: 0.75;
`;

const Spacer = styled.div`
  flex: 1;
`;

const StatusPill = styled.div`
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: ${props =>
    props.active ? "rgba(66, 244, 179, 0.18)" : "rgba(0, 0, 0, 0.08)"};
`;

const formatDistance = distanceMeters => {
  if (!distanceMeters && distanceMeters !== 0) {
    return "Unknown distance";
  }
  return `${(distanceMeters / 1000).toFixed(1)} km`;
};

class RouteItem extends React.Component {
  handleSubmit = fields => {
    const { route, updateRunningRoute } = this.props;
    updateRunningRoute({
      route_id: route.id,
      ...fields
    });
  };

  render() {
    const { route, deleteRunningRoute } = this.props;

    return (
      <CollapsibleSection
        title={
          <HeaderRow>
            <DeleteButton
              confirm={`Delete running route ${route.name}?`}
              onClick={() => deleteRunningRoute(route.id)}
            />
            <NameBlock>
              <Name>{route.name}</Name>
              <Meta>
                {route.city} • {formatDistance(route.distance_meters)} •{" "}
                {route.point_count || 0} points
              </Meta>
            </NameBlock>
            <Spacer />
            <StatusPill active={route.is_active}>
              {route.is_active ? "Active" : "Inactive"}
            </StatusPill>
          </HeaderRow>
        }
        content={
          <RouteForm edit route={route} onSubmit={this.handleSubmit} />
        }
      />
    );
  }
}

export default RouteItem;
